import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { environment } from '../../../../environments/environment';
import { AdminService } from '../../../admin/admin.service';

@Component({
  selector: 'app-confirm-modal',
  templateUrl: './confirm-modal.component.html',
  styleUrls: ['./confirm-modal.component.scss']
})
export class ConfirmModalComponent implements OnInit {
  public theme = environment.applicationName;
  public selectedApp: string;

  constructor(public adminService: AdminService, public dialogRef: MatDialogRef<ConfirmModalComponent>, @Inject(MAT_DIALOG_DATA) public message: any) { }

  ngOnInit() {
    this.selectedApp = this.adminService.selectedApplication;
  }

  changePosition() {
    this.dialogRef.updatePosition({ top: '50px', left: '50px' });
  }
  close(): void {
    this.dialogRef.close();
  }

}
